import { render, staticRenderFns } from "./IbxButton.vue?vue&type=template&id=c51aba4e"
import script from "./IbxButton.vue?vue&type=script&lang=js"
export * from "./IbxButton.vue?vue&type=script&lang=js"
import style0 from "./IbxButton.vue?vue&type=style&index=0&id=c51aba4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports